(ns frontend.test.tiptap
  (:require
   [reagent.core :as r]
   [ui.components.rich-text.tiptap :as tiptap]))

(defn view
  []
  (let [editor-content (r/atom "<p>Initial content with <strong>bold</strong> and <em>italic</em> text.</p>")
        viewer-content (r/atom "<p>This is <strong>read-only</strong> content.</p>")
        change-log (r/atom [])]
    (fn []
      [:div.flex.flex-col.gap-8.p-4

       ;; =========================================================================
       ;; Section 1: Preset Toolbar Configurations
       ;; =========================================================================
       [:section.flex.flex-col.gap-4
        [:h2.text-xl.font-bold "Preset Toolbar Configurations"]
        [:p.text-sm.text-gray-600 "Pre-configured toolbar options matching Draft.js presets"]]

       ;; All Toolbar Options
       [:section.flex.flex-col.gap-4.ml-4
        [:h3.text-lg.font-semibold "all-toolbar-options"]
        [:p.text-sm.text-gray-600 "Full toolbar with all options: alignment, block types, links, and all inline styles"]
        [:pre.bg-gray-100.p-2.rounded.text-xs.overflow-auto
         {:style {:max-width "42rem"}}
         (pr-str tiptap/all-toolbar-options)]
        [tiptap/editor
         (merge tiptap/all-toolbar-options
                {:value "<h1>Heading 1</h1><h2>Heading 2</h2><p>Normal paragraph with <strong>bold</strong>, <em>italic</em>, <u>underline</u>, <s>strikethrough</s>, and <code>monospace</code> text.</p>"
                 :class "max-w-2xl"
                 :on-change #(js/console.log "all-toolbar-options:" %)})]]

       ;; No Align Toolbar Options
       [:section.flex.flex-col.gap-4.ml-4
        [:h3.text-lg.font-semibold "no-align-toolbar-options"]
        [:p.text-sm.text-gray-600 "Toolbar without alignment, with block types and links"]
        [:pre.bg-gray-100.p-2.rounded.text-xs.overflow-auto
         {:style {:max-width "42rem"}}
         (pr-str tiptap/no-align-toolbar-options)]
        [tiptap/editor
         (merge tiptap/no-align-toolbar-options
                {:value "<h1>Heading 1</h1><p>Paragraph without alignment options.</p><ul><li>List item 1</li><li>List item 2</li></ul>"
                 :class "max-w-2xl"
                 :on-change #(js/console.log "no-align-toolbar-options:" %)})]]

       ;; Minimal Toolbar Options
       [:section.flex.flex-col.gap-4.ml-4
        [:h3.text-lg.font-semibold "minimal-toolbar-options"]
        [:p.text-sm.text-gray-600 "Minimal toolbar - just basic formatting (bold, italic, underline)"]
        [:pre.bg-gray-100.p-2.rounded.text-xs.overflow-auto
         {:style {:max-width "42rem"}}
         (pr-str tiptap/minimal-toolbar-options)]
        [tiptap/editor
         (merge tiptap/minimal-toolbar-options
                {:value "<p>Simple editor with <strong>bold</strong>, <em>italic</em>, and <u>underline</u> only.</p>"
                 :class "max-w-2xl"
                 :on-change #(js/console.log "minimal-toolbar-options:" %)})]]

       ;; =========================================================================
       ;; Section 2: Custom Configuration Examples
       ;; =========================================================================
       [:section.flex.flex-col.gap-4
        [:h2.text-xl.font-bold "Custom Configuration Examples"]
        [:p.text-sm.text-gray-600 "Build your own toolbar configuration"]]

       ;; Custom: Only Headings
       [:section.flex.flex-col.gap-4.ml-4
        [:h3.text-lg.font-semibold "Custom: Block Types Only"]
        [:p.text-sm.text-gray-600 "Just block type selection with basic formatting"]
        [:pre.bg-gray-100.p-2.rounded.text-xs.overflow-auto
         {:style {:max-width "42rem"}}
         "{:show-block-type? true\n :block-type-options [:normal :h1 :h2 :h3]\n :show-alignment? false\n :link? false\n :inline-options [:bold :italic]}"]
        [tiptap/editor
         {:value "<h1>Main Title</h1><h2>Subtitle</h2><h3>Section</h3><p>Regular paragraph</p>"
          :show-block-type? true
          :block-type-options [:normal :h1 :h2 :h3]
          :show-alignment? false
          :link? false
          :inline-options [:bold :italic]
          :class "max-w-2xl"
          :on-change #(js/console.log "block-types-only:" %)}]]

       ;; Custom: Links and Alignment
       [:section.flex.flex-col.gap-4.ml-4
        [:h3.text-lg.font-semibold "Custom: Alignment + Links (No Block Types)"]
        [:p.text-sm.text-gray-600 "Alignment and links without heading support"]
        [:pre.bg-gray-100.p-2.rounded.text-xs.overflow-auto
         {:style {:max-width "42rem"}}
         "{:show-block-type? false\n :show-alignment? true\n :link? true\n :inline-options [:bold :italic :underline]}"]
        [tiptap/editor
         {:value "<p>Centered text with <a href=\"https://example.com\">links</a> support.</p>"
          :show-block-type? false
          :show-alignment? true
          :link? true
          :inline-options [:bold :italic :underline]
          :class "max-w-2xl"
          :on-change #(js/console.log "alignment-links:" %)}]]

       ;; Custom: Code-focused
       [:section.flex.flex-col.gap-4.ml-4
        [:h3.text-lg.font-semibold "Custom: Code-focused"]
        [:p.text-sm.text-gray-600 "Monospace and strikethrough for technical writing"]
        [:pre.bg-gray-100.p-2.rounded.text-xs.overflow-auto
         {:style {:max-width "42rem"}}
         "{:show-block-type? false\n :show-alignment? false\n :link? true\n :inline-options [:bold :monospace :strikethrough]}"]
        [tiptap/editor
         {:value "<p>Use <code>inline code</code> for variables and <s>deprecated</s> features.</p>"
          :show-block-type? false
          :show-alignment? false
          :link? true
          :inline-options [:bold :monospace :strikethrough]
          :class "max-w-2xl"
          :on-change #(js/console.log "code-focused:" %)}]]

       ;; =========================================================================
       ;; Section 3: Interactive Editor
       ;; =========================================================================
       [:section.flex.flex-col.gap-4
        [:h2.text-xl.font-bold "Interactive Editor"]
        [:p.text-sm.text-gray-600 "Editor with change tracking"]]

       [:section.flex.flex-col.gap-4.ml-4
        [tiptap/editor
         (merge tiptap/all-toolbar-options
                {:value @editor-content
                 :placeholder "Type something..."
                 :class "max-w-2xl"
                 :on-change (fn [html]
                              (reset! editor-content html)
                              (swap! change-log conj {:time (js/Date.now)
                                                      :html html}))
                 :on-focus #(js/console.log "Editor focused")
                 :on-blur #(js/console.log "Editor blurred")})]

        ;; HTML Output
        [:div.mt-4
         [:h4.font-semibold.mb-2 "HTML Output:"]
         [:pre.bg-gray-100.p-4.rounded.overflow-auto.text-sm
          {:style {:max-height "150px" :max-width "42rem"}}
          @editor-content]]

        ;; Change Log
        [:div.mt-4
         [:div.flex.items-center.gap-2.mb-2
          [:h4.font-semibold "Change Log:"]
          [:button.px-2.py-1.bg-red-500.text-white.rounded.text-xs
           {:on-click #(reset! change-log [])}
           "Clear"]]
         [:div.bg-gray-100.p-4.rounded.overflow-auto
          {:style {:max-height "150px" :max-width "42rem"}}
          (if (empty? @change-log)
            [:p.text-gray-500.text-sm "No changes yet"]
            [:ul.text-sm.space-y-1
             (for [[idx entry] (map-indexed vector (reverse (take 10 @change-log)))]
               ^{:key idx}
               [:li.truncate
                [:span.text-gray-500 (str "#" (- (count @change-log) idx) " ")]
                [:span (:html entry)]])])]]]

       ;; =========================================================================
       ;; Section 4: Read-only Viewer
       ;; =========================================================================
       [:section.flex.flex-col.gap-4
        [:h2.text-xl.font-bold "Read-only Viewer"]
        [:p.text-sm.text-gray-600 "Display rich text without editing"]]

       [:section.flex.flex-col.gap-4.ml-4
        [tiptap/viewer
         {:value @viewer-content
          :class "max-w-2xl border border-gray-200 rounded p-4"}]

        [:div.flex.gap-2.mt-2
         [:button.px-3.py-1.bg-blue-500.text-white.rounded.text-sm
          {:on-click #(reset! viewer-content "<p>Updated <u>underlined</u> content!</p>")}
          "Update content"]
         [:button.px-3.py-1.bg-gray-300.rounded.text-sm
          {:on-click #(reset! viewer-content "<h1>Heading</h1><ul><li>Item 1</li><li>Item 2</li></ul>")}
          "Set list content"]
         [:button.px-3.py-1.bg-gray-300.rounded.text-sm
          {:on-click #(reset! viewer-content "<p>Text with <a href=\"https://example.com\">a link</a></p>")}
          "Set link content"]]]

       ;; =========================================================================
       ;; Section 5: Edge Cases
       ;; =========================================================================
       [:section.flex.flex-col.gap-4
        [:h2.text-xl.font-bold "Edge Cases"]
        [:p.text-sm.text-gray-600 "Testing various scenarios"]]

       ;; Empty State
       [:section.flex.flex-col.gap-4.ml-4
        [:h3.text-lg.font-semibold "Empty State with Placeholder"]
        [tiptap/editor
         {:value ""
          :placeholder "Start typing here..."
          :show-block-type? true
          :block-type-options [:normal :h1 :h2]
          :inline-options [:bold :italic :underline]
          :link? true
          :show-alignment? false
          :class "max-w-2xl"
          :on-change #(js/console.log "Empty editor:" %)}]]

       ;; Custom Toolbar Buttons
       [:section.flex.flex-col.gap-4.ml-4
        [:h3.text-lg.font-semibold "Custom Toolbar Buttons"]
        [tiptap/editor
         {:value "<p>Editor with custom buttons in toolbar</p>"
          :show-block-type? false
          :inline-options [:bold :italic]
          :link? false
          :show-alignment? false
          :class "max-w-2xl"
          :toolbar-custom-buttons
          [:div.flex.gap-1.ml-2
           [:button.px-2.py-1.bg-green-500.text-white.rounded.text-xs
            {:on-click #(js/alert "Custom action 1!")}
            "Action 1"]
           [:button.px-2.py-1.bg-purple-500.text-white.rounded.text-xs
            {:on-click #(js/alert "Custom action 2!")}
            "Action 2"]]
          :on-change #(js/console.log "Custom buttons editor:" %)}]]

       ;; Styled Editor
       [:section.flex.flex-col.gap-4.ml-4
        [:h3.text-lg.font-semibold "Custom Styled Editor"]
        [tiptap/editor
         (merge tiptap/minimal-toolbar-options
                {:value "<p>Custom styled editor with blue theme</p>"
                 :class "max-w-2xl border-2 border-blue-500 rounded-lg overflow-hidden"
                 :editor-class "bg-blue-50 min-h-[150px]"
                 :on-change #(js/console.log "Styled editor:" %)})]]

       ;; =========================================================================
       ;; Section 6: PDF Export Compatibility
       ;; =========================================================================
       [:section.flex.flex-col.gap-4
        [:h2.text-xl.font-bold "PDF Export Compatibility"]
        [:p.text-sm.text-gray-600 "Verify HTML output works with html->pdfmake"]]

       [:section.flex.flex-col.gap-4.ml-4
        (let [test-html @editor-content]
          [:div.space-y-2.max-w-2xl
           [:div.flex.gap-4
            [:p.text-sm
             [:strong "Empty check: "]
             (if (tiptap/empty-editor-value? test-html)
               [:span.text-orange-500 "Empty"]
               [:span.text-green-500 "Has content"])]]])]])))
